import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

class AutosuggestMultiSectionExpandable extends Component {
  state = {
    expandedSections: [],
    filterValue: ""
  };

  onSuggestionSelected = (event, { suggestion, ...rest }) => {
    if (suggestion.isExpandTrigger) {
      event.preventDefault();
      this.setState({
        expandedSections: [...this.state.expandedSections, suggestion.section]
      });
      return false;
    }
    return this.props.onSuggestionSelected(event, { suggestion, ...rest });
  };

  onSuggestionsFetchRequested = ({ value, reason }) => {
    const { searchValue } = this.props;
    const filterValue =
      value === "-expand-section-trigger-" ? searchValue : value;
    this.props.onSuggestionsFetchRequested({ value: filterValue, reason });

    if (
      (reason === "input-changed" || reason === "suggestion-selected") &&
      !isEmpty(searchValue)
    ) {
      const newState = {};
      newState.filterValue = value;
      if (this.state.expandedSections.length > 0) {
        newState.expandedSections = [];
      }
      this.setState(newState);
    }
  };

  getSectionSuggestions = section => {
    const { sectionCutoffLength, getSectionSuggestions } = this.props;
    const { expandedSections } = this.state;

    const sectionSuggestions = getSectionSuggestions(section);
    if (
      sectionSuggestions.length <= sectionCutoffLength ||
      expandedSections.includes(section.name)
    ) {
      return sectionSuggestions;
    }

    const expandableSectionSuggestions = sectionSuggestions.slice(
      0,
      sectionCutoffLength
    );
    expandableSectionSuggestions.push({
      isExpandTrigger: true,
      section: section.name,
      value: "-expand-section-trigger-"
    });

    return expandableSectionSuggestions;
  };

  getSuggestionValue = suggestion =>
    suggestion.isExpandTrigger
      ? suggestion.value
      : this.props.getSuggestionValue(suggestion);

  renderSuggestion = suggestion => {
    if (suggestion.isExpandTrigger) {
      return (
        <div className="section-expand-link" data-testid="section_expand_link">
          ...more
        </div>
      );
    }
    return this.props.renderSuggestion(suggestion);
  };

  renderSuggestionsContainer = ({ containerProps, children }) => (
    <div
      {...containerProps}
      className={`${containerProps.className} react-autosuggest__container--expandable`}
      data-testid={"search-autosuggest-container"}
    >
      {children}
    </div>
  );

  render() {
    return (
      <Autosuggest
        {...this.props}
        multiSection
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        onSuggestionSelected={this.onSuggestionSelected}
        getSectionSuggestions={this.getSectionSuggestions}
        renderSuggestion={this.renderSuggestion}
        getSuggestionValue={this.getSuggestionValue}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
      />
    );
  }
}

AutosuggestMultiSectionExpandable.propTypes = {
  sectionCutoffLength: PropTypes.number,
  getSectionSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  renderSuggestion: PropTypes.func.isRequired,
  getSuggestionValue: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired //
    })
  ).isRequired
};

AutosuggestMultiSectionExpandable.defaultProps = {
  sectionCutoffLength: 5
};

export default AutosuggestMultiSectionExpandable;
